module.exports = __webpack_public_path__ + "img/emoji-smile.f5662612.svg";